/*
This file contains all functions for uploadJs connecting with backend - communication via JSON
*/

import axios from 'axios';
import propertiesTemplate from './data/TemplatePropertiesDTO.json';
// import { configRestPath, configDebugFlag } from '../utils/configUtils';

// const { ENVIRONMENT } = window;
const { DEBUG_FLAG } = window;
const { REST_PATH } = window;

const RightNames = {
  OFFICE: ['Amt'],
  FREE: ['%C3%96ffentlich'],
  GRP: ['Gruppen'],
  BEN: ['Benutzer'],
};

// log function for debugging - can be deactivated by flag
const log = function consoleLog(...args) {
  // eslint-disable-next-line no-console
  if (DEBUG_FLAG) console.log(...args);
};

// initiating import creation on selecting file in Upload
export const postImportInit = async () => {
  log('starts: postImportInit');
  const returnMessage = JSON.stringify(propertiesTemplate).replace(
    /\$SESSIONID/,
    sessionStorage.getItem('uuid'),
  );
  log('message sent:', returnMessage);
  const res = await axios
    .post(
      `${REST_PATH}import/init`,
      returnMessage,
      { headers: { 'Content-Type': 'application/json' } },
    )
    .catch((error) => {
      log(error);
    });
  log('############ Success # Answer received:', res);
  return res.data;
};

// upload file for data import or ptable, not Metadata
export const postImportData = async (file, path, formValues) => {
  let { startTimePass, ownerName, rightsSelection } = formValues;
  if (startTimePass === '') startTimePass = undefined;
  // if (latestStart === '') latestStart = undefined;
  if (ownerName === '') ownerName = undefined;
  if (rightsSelection === '') rightsSelection = undefined;
  let fullpath = REST_PATH + path +'?uuid='+sessionStorage.getItem('uuid');
  // returnMessage = returnMessage.replace(/\$SESSIONID/,sessionStorage.getItem('uuid'),);
  if (startTimePass) fullpath = fullpath + '&earliestStart='+startTimePass.replace(/ /,'%20',);
  // if (latestStart) fullpath = fullpath + '&latestStart='+latestStart;
  if (ownerName) fullpath = fullpath + '&alternateUser='+ownerName;
  if (rightsSelection) fullpath = fullpath + '&rightArea='+RightNames[rightsSelection];
  const data = new FormData();
  data.append('attachment', file);
  // data.append('alternateUser', ownerName);
  // data.append('earliestStart', startTimePass);
  // data.append('latestStart', '');
  // data.append('rightArea', RightNames[rightsSelection]);
  console.log('FULLPATH', fullpath);
  const res = await axios({
    method: 'post',
    url: fullpath,
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
    .then((response) => {
      // handle success
      let successtext = response;
      if (response.data) successtext = response.data;
      if (typeof successtext === 'object') successtext = 'Importauftrag erstellt';
      log('Message to be returned: ', successtext);
      return [`Dateiimport: ${successtext}`, 'success'];
    })
    .catch((response) => {
      // handle error
      let errortext = response;
      if (response.response) errortext = response.response.data;
      log('This is the error to be returned: ', errortext);
      return [`Beim Datenimport ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administator: ${errortext}`, 'error'];
      return [`Beim Datenimport ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administator.`, 'error'];
    });
  return res;
};

//  initiating upload on selecting upload in Upload
export const postImportInsert = async (ret, name, content, formValues, path) => {
  log('start: postImportInsert', formValues);
  let { rightsSelection } = formValues;
  if (!rightsSelection) rightsSelection = 'OFFICE';
  // file DTO value
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.file.mimeType = 'text_csv';
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.file.charset = 'UTF-8';
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.file.name = name;
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.file.content = content;
  // insert other owner?
  if (formValues.ownerName !== '') {
    ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.alternativeOwnerInfo.user = formValues.ownerName;
    ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.alternativeOwnerInfo.userID = -1;
  }
  // form values:
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.importMode = formValues.importMode;
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.importNewFlag = formValues.importNewFlag;
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.importModifyFlag = formValues.importModifyFlag;
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.deleteTimeSlicesFirst = formValues.deleteTimeSlicesFirst;
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.importMetadata = true;
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.importDataset = false;
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.lockTimeSlice = formValues.lockTimeSlice;
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.buildThesaurusAfterImport = formValues.buildThesaurusAfterImport;
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.multilingual = formValues.multilingual;
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.modus = formValues.modus;
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.startTime = formValues.startTimePass;
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.startTimeFlag = formValues.startTimeFlag;
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.endTime = formValues.endTimePass;
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.endTimeFlag = formValues.endTimeFlag;
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.userName = formValues.userName;
  // remove verbose menu description for Genesis client
  ret.contents['genesis.container.content.GenesisTMContent'].menuRoot = {};
  // set rightArea to "OFFICE" or selection
  ret.contents['genesis.container.content.GenesisTMContent'].transfermodel.ownerInfo.rightArea = rightsSelection;

  let returnMessage = JSON.stringify(ret);
  log('message sent:', returnMessage);
  const res = await axios
    .post(
      REST_PATH + path,
      returnMessage,
      { headers: { 'Content-Type': 'application/json' } },
    )
    .catch((error) => {
      log(error);
    });
  returnMessage = res;
  returnMessage.data.contents[
    'genesis.container.content.GenesisTMContent'
  ].menuRoot = [];
  log('############ Success # Answer received:');
  log((returnMessage.data));
  log(JSON.stringify(returnMessage.data));
  return returnMessage.data;
};

/* async postUploadDataset(ret, name, content, formValues, file) {
    log('start: postUploadDataset');
    // file DTO value

    let returnMessage = JSON.stringify(ret);
    log('message sent:');
    log(returnMessage);
    const data = new FormData();
    data.append('attachment', file);
    // let protoRestPath = "http://genesis-test-app01-neu:38080/genesisHSSTAT/rest2/"
    let newPathUpload = `${REST_PATH}file/upload`;
    log('postUploadDataset newPathUpload', newPathUpload);
    const res = await axios
      .post(
        newPathUpload,
        data,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      )
      .catch((response) => {
        // handle error
        let errortext = response;
        if (response.response) errortext = response.response.data;
        console.log('This is the error to be returned: ', errortext);
        return [`Dateiimport: ${errortext}`, 'error'];
        // console.log("This is the error to be returned", error);
        // return ["Dateiimport: " + error.message, "error"];
      });
    returnMessage = res;
    log('############ Success # Answer received:');
    log('returned in postUploadDataset', res);
    newPathUpload = `${REST_PATH}file/import?uuid=${sessionStorage.getItem('uuid')}&file=${name}`;
    log('############ now sending get request: newPathUpload', newPathUpload);
    // let res1 = await axios.post(newPathUpload)
    const res1 = await axios.get(newPathUpload)
      .catch((error) => {
        log('Request Error: ', error.request);
        log(JSON.stringify(error));
        log('Error Message:', error.message);
        return [`Auftragserstellung: ${error.message}`, 'error'];
      });
    return res1;
  } */
